import { useState } from 'react'
import { cn } from '@/shared/lib/cn'
import { IconChevron } from './ToolIcons'

interface InlineToolResultProps {
  content: string
  isError: boolean
}

export function InlineToolResult({ content, isError }: InlineToolResultProps) {
  const [expanded, setExpanded] = useState(false)
  const isEmpty = !content.trim()
  const preview = isEmpty ? '(empty)' : content.length > 80 ? content.slice(0, 80) + '…' : content

  return (
    <div className={cn(
      'my-0.5 rounded-lg border overflow-hidden text-xs max-w-[85%]',
      isError ? 'border-red-500/20 bg-red-500/[0.04]' : 'border-white/5 bg-white/[0.02]',
    )}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-2 px-2.5 py-1 text-left hover:bg-white/5 transition-colors"
      >
        <IconChevron className="w-3 h-3 flex-shrink-0 text-white/20" expanded={expanded} />
        <span className={cn('font-mono truncate', isError ? 'text-red-400/70' : 'text-white/30')}>
          {isError ? '✕ ' : '↩ '}{isEmpty ? '(empty)' : preview}
        </span>
      </button>
      {expanded && (
        <div className="border-t border-white/5 px-3 py-2 max-h-64 overflow-y-auto">
          <pre className={cn(
            'whitespace-pre-wrap break-all font-mono text-xs leading-snug',
            isError ? 'text-red-400/70' : 'text-white/50',
          )}>
            {content || '(empty)'}
          </pre>
        </div>
      )}
    </div>
  )
}
